// extracted by css-extract-rspack-plugin
export default {"wrap":"EmailTemplatePreview_wrap__IQPcP","content":"EmailTemplatePreview_content__pMKwj"};